import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCmsFiles,
  createCmsFile,
  updateCmsFile,
  deleteCmsFile,
} from "../../api/carouselManagement";

// Thunk action for getting CMS files
export const fetchCmsFiles = createAsyncThunk(
  "cmsFiles/fetch",
  async (params, { rejectWithValue }) => {
    try {
      const response = await getCmsFiles(params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

// Thunk action for creating a CMS file
export const addCmsFile = createAsyncThunk(
  "cmsFiles/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await createCmsFile(data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

// Thunk action for updating a CMS file
export const updateCmsFileAction = createAsyncThunk(
  "cmsFiles/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateCmsFile(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);

// Thunk action for deleting a CMS file
export const removeCmsFile = createAsyncThunk(
  "cmsFiles/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteCmsFile(id);
      return { ...response, id }; // Including id in response for state update
    } catch (error) {
      return rejectWithValue(error.response?.data || error);
    }
  }
);